import {
  removeEntity,
  _emailIsValid,
  _urlIsValid,
} from "../../utils/documentUtils";
import getEditorHTML from "../../components/RevvEditor/getEditorHtml";

export const prepareDocAnalysisDataOld = analysis => {
  const docAnalysisData = [];
  analysis.forEach(item => {
    const { rule, ...rest } = item.workflow;
    const tempObj = { ...rest };
    tempObj.reasons = item.reasons;
    const approvalActionItem = item.workflow.rules.find(
      ruleItem => ruleItem.action.type === "APPROVAL",
    ).action;
    tempObj.approvers = approvalActionItem.data.levels[0].approvers;
    docAnalysisData.push(tempObj);
  });
  return docAnalysisData;
};

export const prepareDocAnalysisData = analysis => {
  const docAnalysisData = [];
  analysis.forEach(item => {
    item.rules.forEach(rule => {
      const tempObj = {};
      const tempApprovers = [];
      const tempGrpApprovers = [];
      rule.action.data.levels.forEach(level => {
        if (level.approvers && level.approvers.length > 0) {
          tempApprovers.push(level.approvers);
        }
        if (level.group_approvers && level.group_approvers.length > 0) {
          tempGrpApprovers.push(level.group_approvers);
        }
      });
      tempObj.id = rule.id;
      tempObj.approvers = tempApprovers.flat();
      tempObj.groupApprovers = tempGrpApprovers.flat();
      tempObj.triggeMessage = rule.action.trigger_message;
      docAnalysisData.push(tempObj);
    });
  });
  return docAnalysisData;
};

export const prepareDocApprovalStatusData = approvalStatus => {
  const approvalStatusData = [];
  const pendingApprovers = [];
  const allApprovers = [];
  if (approvalStatus) {
    approvalStatus.forEach(item => {
      const tempObj = {};
      tempObj.workflowID = item.id;
      tempObj.workflowStatus = item.status;
      tempObj.reasons = item.reason.split("\n");
      tempObj.name = item.trigger;
      if (item.levels[0].approvers) {
        tempObj.approvers = item.levels[0].approvers.map(i => {
          if (i.status === "PENDING") {
            pendingApprovers.push(i.id);
          }
          allApprovers.push(i.id);
          return i;
        });
      } else {
        tempObj.approvers = [];
      }
      approvalStatusData.push(tempObj);
    });
  }
  return { approvalStatusData, pendingApprovers, allApprovers };
};

export const prepareCollaboratorsData = approvals => {
  const collaboratorsData = [];
  if (approvals) {
    approvals.forEach(approval => {
      const tempObj = { approvers: [] };
      if (approval.type === "PARALLEL" || approval.type === "") {
        const tempAllApprovers = [];
        const tempApprovers = [];
        const tempGrpApprovers = [];
        approval.levels.forEach(level => {
          if (level.approvers && level.approvers.length > 0) {
            tempApprovers.push(level.approvers);
          }
          if (level.group_approvers && level.group_approvers.length > 0) {
            tempGrpApprovers.push(level.group_approvers);
          }
          tempAllApprovers.push(
            tempGrpApprovers.flat().concat(tempApprovers.flat()),
          );
        });
        tempObj.approvers = tempAllApprovers.flat();
      } else if (approval.type === "SEQUENTIAL") {
        const tempApprovers = [];
        approval.levels.forEach(level => {
          if (level.approvers && level.approvers.length > 0) {
            tempApprovers.push(level.approvers);
          }
          if (level.group_approvers && level.group_approvers.length > 0) {
            tempApprovers.push(level.group_approvers);
          }
        });
        tempObj.approvers = tempApprovers.flat();
      }

      tempObj.id = approval.id;
      tempObj.triggeMessage = approval.reason;
      tempObj.approvalType = approval.type;
      collaboratorsData.push(tempObj);
    });
  }
  return collaboratorsData;
};

export const removeEntityFromSection = (
  section,
  entityID,
  accept,
  mode = "DOCUMENT",
) => {
  const { data, currentContent } = section;
  const updatedData = removeEntity(data, entityID, accept);
  const updatedContent = removeEntity(currentContent, entityID, accept);
  const updatedHTML = getEditorHTML(updatedContent, mode);
  return {
    ...section,
    data: updatedData,
    currentContent: updatedContent,
    html: updatedHTML,
  };
};

export const validateDocForm = (form = [], components = {}) => {
  let isValid = true;
  if (form.length === 0) {
    return isValid;
  }

  // get all the dynamic field form
  const dynamicFieldForm = form.filter(
    f => f.type !== "CLAUSE" && f.occurrences.length > 0,
  );

  // check valid state for dynamic field
  for (let index = 0; index < dynamicFieldForm.length; index += 1) {
    const field = dynamicFieldForm[index];
    const value = field.value || (field.meta && field.meta.default);
    if (value === null || value === "" || value === undefined) {
      isValid = false;
      break;
    }
    if (field.type === "ADDRESS") {
      if (
        value.addressLineOne === "" ||
        value.city === "" ||
        value.state === "" ||
        value.zip === ""
      ) {
        isValid = false;
        break;
      }
    }
    if (field.type === "EMAIL" && !_emailIsValid(value)) {
      isValid = false;
      break;
    }
    if (field.type === "URL" && !_urlIsValid(value)) {
      isValid = false;
      break;
    }
    if (field.type === "PERCENT" && (value < 0 || value > 100)) {
      isValid = false;
      break;
    }
    if (field.type === "PHONE") {
      const re = /^[0-9\b]+$/;
      if (!re.test(value)) {
        isValid = false;
        break;
      }
    }
    if (field.type === "PERIOD" || field.type === "PERSON_NAME") {
      for (let i = 0; i < Object.values(value).length; i += 1) {
        const element = Object.values(value)[i];
        if (element === "" || element === null) {
          isValid = false;
          break;
        }
      }
    }
  }

  // check for all the clause options except for optional, everything should be field
  Object.keys(components).forEach(componentId => {
    const section = components[componentId].content;
    const { clauseOptions } = section;
    if (clauseOptions) {
      const { id, value } = clauseOptions;
      const clause = form.find(f => f.id === id);
      if (
        clause &&
        clause.meta &&
        clause.meta.subtype !== "optional" &&
        clause.meta.subtype !== "free_text"
      ) {
        if (
          clause.meta.subtype === "multi_select" &&
          value &&
          Array.isArray(value) &&
          value.length === 0
        ) {
          isValid = false;
        } else if (!value) {
          isValid = false;
        }
      }
    }
  });

  return isValid;
};

// putting this in actions file creates Dependency cycle as it is used in services file
export const updateDocSaveIndicator = val => dispatch => {
  dispatch({
    type: "UPDATE_DOC_SAVE_INDICATOR",
    payload: val,
  });
};

export const updateComponentsDBRowColIndexesAction = newComponents => dispatch => {
  dispatch({
    type: "UPDATE_COMPONENTS_DB_ROW_COL_INDEXES",
    payload: { newComponents },
  });
};



// WEBPACK FOOTER //
// ./src/actions/DocumentActions/method.js